<template>
	<div class="video-youtube-iframe">
		<iframe
			v-if="showVideo"
			ref="iframe"
			frameborder="0"
			allowfullscreen
			allow="autoplay"
			:src="videoYoutubeUrl"
			loading="lazy"
			:title="title"
		></iframe>
	</div>
</template>

<script>
export default {
	name: 'VideoYoutubeIframe',

	props: {
		gtm: { type: String, required: false, default: 'not-tracked' },
		videoId: { type: String, required: true },
		title: { type: String, required: false, default: '' },
		autoplay: { type: Boolean, required: false, default: false },
	},

	data() {
		return {
			showVideo: false,
			youtubeId: null,
			autoplayValue: this.autoplay ? 1 : 0,
		};
	},

	computed: {
		videoYoutubeUrl() {
			return `https://www.youtube.com/embed/${this.youtubeId}?rel=0&showinfo=0&autoplay=${this.autoplayValue}&enablejsapi=1`;
		},
	},

	watch: {
		videoId(newId) {
			this.showVideo = false;
			this.youtubeId = newId;
			this.showVideo = true;
		},
	},

	created() {
		this.youtubeId = this.videoId;
		this.showVideo = true;
	},
};
</script>

<style lang="scss" scoped>
.video-youtube-iframe {
	background-color: $color-black;
	cursor: pointer;
	// margin-bottom: 30px;
	overflow: hidden;
	padding-top: 56.25%;
	position: relative;

	iframe {
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}
}
</style>
